// extracted by mini-css-extract-plugin
export default {"select":"CoursePauseTypeSelect_select__HxSLS"};